import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import Edit from './edit.vue';
import CheckInfo from './components/checkInfo.vue';
import infoList from "@/mixins/infoList";
import { getList } from "@/api/config";
export default {
  components: {
    Edit: Edit,
    CheckInfo: CheckInfo
  },
  name: "formSys",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getList,
      form_id: 0,
      showEdit: false,
      showCheck: false,
      statusOptions: {
        0: "正常",
        1: "停止",
        2: "删除"
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTableData();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleAdd: function handleAdd() {
      this.form_id = 0;
      this.showEdit = true;
    },
    handleCheck: function handleCheck(e) {
      this.checkID = e;
      this.showCheck = true;
    },
    handleEdit: function handleEdit(e) {
      this.form_id = e;
      this.showEdit = true;
    },
    backFather: function backFather() {
      this.init();
      this.showEdit = false;
    }
  }
};